import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Dialog onOpenAutoFocus for picker dialogs with a search box: on touch screens focus the
// dialog itself, so the on-screen keyboard only opens when the user taps the search box.
// Mouse and keyboard users keep the default (the search box is focused, ready to type).
export function focusDialogWithoutKeyboard(event: Event) {
  if (!window.matchMedia('(pointer: coarse)').matches) return
  event.preventDefault()
  ;(event.currentTarget as HTMLElement | null)?.focus()
}
